export const scrollToInvalidField = () => {
    // Scroll to the first required field that has an error
    // Get the parent, parent (the field) and scroll to it
    document
        .querySelector('.block-page .stk-field-error')
        ?.parentElement?.parentElement?.scrollIntoView()
}
